import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject
} from '@angular/core';

import { CgpTreeviewService } from './cgp-treeview.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'cgp-treeview',
  templateUrl: './cgp-treeview.component.html',
  styleUrls: ['./cgp-treeview.component.scss']
})
export class CgpTreeviewComponent implements OnInit {
  dataSource: any[] = [];

  constructor(private service: CgpTreeviewService) { }

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.service.dataSource$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(dataSource => this.dataSource = dataSource);
    this.service.get();
  }

  @Output() focus: EventEmitter<any[]> = new EventEmitter();

  ngOnChanges() {
    this.stateChange(this.dataSource);
  }

  stateChange(dataItems: any[]) {
    this.focus.emit(dataItems);
  }


  getColor = (obj): string => {
    let color: string;
    let itemType: string = obj.HierarchicalDetailsType;
    switch (itemType.toLowerCase()) {
      case 'system layout':
        color = '#dadada'
        break;
      case 'cell':
        color = '#ecf4d7'
        break;
      case 'station':
        color = '#ecdfea'
        break;
      case 'tool':
        color = '#fff3cc'
        break;
      case 'kit':
        color = '#fcdbcf'
        break;
      default:
        color = '#ccc'
        break;
    }
    return color;
  }

}

